import { configureRequest, replacePathVariables } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { getUserRoleForBackend } from '../../../../shared/functions/UserRole/userRoleManagment.functions'
import {
  UpdateUspsLocationErrorResponse,
  UpdateUspsLocationRequest,
  UpdateUspsLocationSuccessResponse
} from './updateUspsLocation.types'

export const updateUspsLocationApi = async (
  request: UpdateUspsLocationRequest
): Promise<UpdateUspsLocationSuccessResponse> => {
  const response = await configureRequest({
    url: replacePathVariables(urls.fulfillmentOrders.updateUspsLocation, { orderId: request.orderId }),
    method: 'PUT',
    headers: {
      'X-User-Role': getUserRoleForBackend()
    },
    data: {
      zipCode: request.zipCode,
      locationId: request.locationId,
      locationAddress: request.locationAddress
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as UpdateUspsLocationSuccessResponse
  } else {
    throw response as UpdateUspsLocationErrorResponse
  }
}

export default updateUspsLocationApi
